import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {object} from 'yup'
import {CreateData, UpdateData, GetAllData} from '../../Tags/TagSlice/TagsSlices'
import {TwitterPicker} from 'react-color'
import {startLoadding, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {useUpsertTagMutation} from '../../../../../../services/cellcast.v3'
import {GetCurrentData} from '../../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../../_metronic/helpers'
import {toast} from 'react-toastify'

const CreateTagsPopup = ({show, handleClose, tagName, setTagName, callback}: any) => {
  const [upsertTag] = useUpsertTagMutation()
  const currentUser = GetCurrentData()

  const [name, setName] = useState('')
  const dispatch = useDispatch()
  const [tagColor, setTagColor] = useState('#7bdcb5')
  const [error, setError] = useState('')

  const handleSubmit = () => {
    if (Object.values(tagName).length == 0) {
      dispatch(
        CreateData({
          name: name,
          color: tagColor,
        })
      )
      setName('')
      handleClose()
    } else {
      dispatch(UpdateData({data: {name: name, color: tagColor}, id: tagName?.id}))
      setName('')
      handleClose()
    }
  }

  const handleSubmitV3 = async () => {
    dispatch(startLoadding())
    if (Object.values(tagName).length == 0) {
      const result = await upsertTag({
        action: 'create_tag',
        data: {
          name: name,
          color: tagColor,
          type: 'tag',
        },
      }).unwrap()
      if (result.data?.is_error) {
        toast.success(result.data.message)
      }
      setName('')
      handleClose()
      if (callback) {
        callback()
      }
    } else {
      const result = await upsertTag({
        action: 'update_tag',
        data: {
          name: name,
          color: tagColor,
          tag_id: tagName?.id,
        },
      }).unwrap()
      if (result.data?.is_error) {
        toast.success(result.data.message)
      }
      setName('')
      handleClose()
      if (callback) {
        callback()
      }
    }
    dispatch(stopLoading())
  }

  useEffect(() => {
    setName(tagName?.name)
    setTagColor(tagName?.color)
  }, [tagName?.id, show])

  const handleChangeColor = (color: any) => {
    setTagColor(color.hex)
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-450px'
        className='vh-100'
        show={show}
        onHide={() => {
          handleClose()
          setTagName('')
        }}
      >
        <div className='modal-header'>
          <h1>{tagName?.id ? 'Edit Tag' : 'Create New TAG'}</h1>
        </div>
        <div className='modal-body p-10 '>
          <label className=' col-form-label required fw-bold fs-6'>Tag Name</label>
          <input
            onBlur={() => {
              ;/^[a-zA-Z0-9_ -]{2,25}$/.test(name)
                ? setError('')
                : setError('please enter valid tag ')
            }}
            name='Description'
            value={name}
            maxLength={50}
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='i.e. "Active"'
            onChange={(e: any) => {
              setError('')
              setName(e.target.value)
            }}
          />

          {name && (
            <>
              <label className=' col-form-label required fw-bold fs-6'>Color</label>
              <div
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-white'
                style={{backgroundColor: tagColor}}
              >
                {name}
              </div>

              <TwitterPicker onChange={handleChangeColor} triangle='hide' />
            </>
          )}
          <span className='text-danger mt-1'>{error}</span>

          <div className='d-flex justify-content-end mt-10'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={() => {
                  handleClose()
                  setTagName('')
                }}
                className='btn btn-sm me-2 w-100px p-3 fw-500 me-2 gray_bg_purple'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              disabled={name == ''}
              onClick={() =>
                currentUser?.region === defaultRegion ? handleSubmit() : handleSubmitV3()
              }
            >
              <span className='indicator-label'>{tagName?.id ? 'Update' : 'Create'} tag</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateTagsPopup
